export function gravityFormsSubmit() {
	// Gravity Forms AJAX submission handler
	jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
		// Get current URL
		const url = new URL(window.location.href);

		// Add query parameter
		url.searchParams.set('form-submitted', 'true');

		// Update URL without page reload
		window.history.pushState({}, '', url);
	});
}
